/**
 * 初始化一些数据，保证页面刷新时store中的数据都是有赋值的
 */

import { useAppStore, useUserStore } from '@/store'
import defaultConfig from '@/configs/default.config'
import storage from '@/utils/storage'

export default {
  init() {
    console.log('载入默认配置')
    const appStore = useAppStore()
    const userStore = useUserStore()

    appStore.$patch({
      host: defaultConfig.host,
      version: defaultConfig.version,
      checkAuth: defaultConfig.check_auth,
      projectTitle: defaultConfig.project_title,
      contactWay: defaultConfig.contact_way,
      company: defaultConfig.company,
      copyright: defaultConfig.copyright,
    })

    userStore.setToken(storage.get<string>('BEARER_TOKEN') as string)
  }
}

// host: process.env.VUE_APP_HOST,
// version: process.env.VUE_APP_VERSION,
// check_auth: process.env.VUE_APP_CHECK_AUTH,
// project_title: process.env.VUE_APP_PROJECT_TITLE,
// contact_way: process.env.VUE_APP_CONTACT_WAY,
// copyright: process.env.VUE_APP_COPYRIGHT,
// company: process.env.VUE_APP_COMPANY